<template>
  <AssoListView></AssoListView>
</template>

<script>
import AssoListView from '@/components/Associations/AssoListView.vue'

export default {
  name: 'HomeView',
  components: {
    AssoListView
  }
}
</script>
